import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CloudUpload, X } from 'lucide-react';
import { Container } from '@easymoving/ui';
import { useOptionalBackend } from '../../lib/backend/context';

const DISMISS_KEY = 'easymoving.guestBannerDismissed';

/** Shown only in guest (local) mode: gentle nudge to create an account. */
export function GuestBanner() {
  const { t } = useTranslation();
  const backend = useOptionalBackend();
  const [dismissed, setDismissed] = useState(
    () => typeof localStorage !== 'undefined' && localStorage.getItem(DISMISS_KEY) === '1',
  );

  if (!backend || backend.mode !== 'local' || dismissed) return null;

  return (
    <div className="print:hidden bg-petrol-tint border-b border-petrol/15">
      <Container className="flex items-center gap-3 py-2 text-[13px]">
        <CloudUpload className="size-4 text-petrol-deep shrink-0" />
        <span className="text-petrol-deep flex-1">{t('guest.banner')}</span>
        <Link
          to="/signup"
          className="font-semibold text-petrol-deep underline underline-offset-2 whitespace-nowrap"
        >
          {t('guest.bannerCta')}
        </Link>
        <button
          type="button"
          aria-label={t('guest.dismiss')}
          onClick={() => {
            localStorage.setItem(DISMISS_KEY, '1');
            setDismissed(true);
          }}
          className="text-petrol-deep/60 hover:text-petrol-deep p-0.5"
        >
          <X className="size-4" />
        </button>
      </Container>
    </div>
  );
}
